module.exports = __webpack_public_path__ + "static/media/train10.b9ec231c.png";